import { useEffect, useState } from 'react';
import { countdownLong } from '../lib/format';

// Re-renderiza cada `ms` para que el contador avance en vivo.
export function useTick(ms = 1000) {
  const [, setN] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setN((n) => n + 1), ms);
    return () => clearInterval(t);
  }, [ms]);
}

export function Countdown({ to }: { to: string | null }) {
  useTick(1000);
  return <>{countdownLong(to)}</>;
}
